import React from 'react'
import {Link} from 'react-router-dom'
import Editicon from '../../assets/edit.svg'


export default function RecipeDetails({recipe}) {

  return (

    <div key={recipe.id}>

    <h2 className="page-title">{recipe.title}</h2>
    <p>{recipe.cookingTime} to make...</p>
    <ul>
        Ingredients: {recipe.ingredients.map((ing)=>(
            <li key={ing}>{ing}</li>
        ))}
    </ul>
    <p className="method">{recipe.method}</p>
    <Link className='aaa' to={`/edit/${recipe.id}`}>
                {/* { <img className='edit' alt='edit icon'
                  src={Editicon}
                  />} */}
                  EDIT
                </Link> 
                
    </div>

    
  )
}
